import { Check, Phone, Users, Sparkles } from "lucide-react";
import { PRICING, SITE } from "@/lib/site";

export default function Pricing() {
  return (
    <section id="preturi" data-testid="pricing-section" className="relative py-24 lg:py-36 px-5 lg:px-10 bg-[#fcf3e6] ad-grain">
      <div className="max-w-7xl mx-auto relative">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-7">
            <div className="text-[#048a93] uppercase text-[11px] tracking-[0.32em] font-semibold mb-5">
              <span className="inline-block h-px w-10 bg-[#048a93] align-middle mr-3" />
              Prețuri & Pachete
            </div>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] text-[#012a2d]" data-testid="pricing-title">
              Tarife clare, <span className="italic text-[#048a93]">fără surprize</span>.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="font-sans-ui text-[#1a2421]/75 leading-relaxed">
              Tarifele de mai jos sunt pentru un grup de până în <span className="font-semibold text-[#012a2d]">30 de persoane</span> (adulți + copii). Pentru grupuri mai mari se aplică o taxă suplimentară — te rugăm să ne contactezi pentru ofertă.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {PRICING.map((p, idx) => (
            <article
              key={p.title}
              data-testid={`pricing-card-${idx}`}
              className="group relative bg-white rounded-[2rem] p-8 lg:p-10 border-2 border-transparent hover:border-[#048a93] transition-all duration-500 hover:-translate-y-1 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_50px_rgb(4,138,147,0.12)]"
            >
              {p.badge && (
                <span className="absolute -top-3 left-8 bg-[#012a2d] text-[#fcf3e6] text-[10px] uppercase tracking-[0.25em] font-semibold px-4 py-1.5 rounded-full">
                  {p.badge}
                </span>
              )}
              <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
                <div className="flex-1">
                  <h3 className="font-serif-display text-3xl lg:text-4xl text-[#012a2d] leading-tight">{p.title}</h3>
                  <p className="font-sans-ui text-sm text-[#1a2421]/60 mt-2">{p.subtitle}</p>
                </div>
                <div className="text-right">
                  <div className="font-serif-display text-5xl lg:text-6xl text-[#048a93] leading-none">
                    {p.price}
                    <span className="text-base ml-1 text-[#012a2d]/60 align-top">RON</span>
                  </div>
                </div>
              </div>

              <div className="h-px bg-[#e2d5c3] my-7" />

              <ul className="space-y-3 font-sans-ui text-sm text-[#1a2421]/75">
                {(p.features || []).map((feat) => (
                  <li key={feat} className="flex items-center gap-3">
                    <span className="h-5 w-5 rounded-full bg-[#048a93]/10 flex items-center justify-center shrink-0">
                      <Check className="h-3 w-3 text-[#048a93]" strokeWidth={3} />
                    </span>
                    {feat}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        {/* Group surcharge banner */}
        <div className="mt-10 bg-[#012a2d] text-[#fcf3e6] rounded-[2rem] p-8 lg:p-10 flex flex-col md:flex-row items-start md:items-center gap-6 justify-between" data-testid="pricing-group-banner">
          <div className="flex items-start gap-5">
            <div className="h-14 w-14 rounded-2xl bg-[#048a93]/20 flex items-center justify-center shrink-0">
              <Users className="h-6 w-6 text-[#048a93]" />
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-[0.25em] text-[#048a93] font-semibold mb-1">Grupuri mari</div>
              <div className="font-serif-display text-2xl lg:text-3xl">Peste 30 de persoane?</div>
              <div className="font-sans-ui text-[#fcf3e6]/70 text-sm mt-1">Se aplică o taxă suplimentară. Te rugăm să ne suni pentru o ofertă personalizată.</div>
            </div>
          </div>
          <a
            href={SITE.phoneHref}
            className="inline-flex items-center gap-3 bg-[#048a93] hover:bg-[#fcf3e6] hover:text-[#012a2d] text-white rounded-full px-7 py-3.5 transition-all font-sans-ui text-sm font-medium shrink-0"
            data-testid="pricing-group-call-button"
          >
            <Phone className="h-4 w-4" />
            Cere ofertă
          </a>
        </div>

        {/* Partners note */}
        <div className="mt-6 bg-white border-2 border-[#048a93]/20 rounded-[2rem] p-8 lg:p-10 flex items-start gap-5" data-testid="pricing-partners-note">
          <div className="h-14 w-14 rounded-2xl bg-[#048a93]/10 flex items-center justify-center shrink-0">
            <Sparkles className="h-6 w-6 text-[#048a93]" />
          </div>
          <div>
            <div className="text-[11px] uppercase tracking-[0.25em] text-[#048a93] font-semibold mb-1">Servicii la cerere</div>
            <div className="font-serif-display text-2xl lg:text-3xl text-[#012a2d]">Catering, decor și baloane</div>
            <div className="font-sans-ui text-[#1a2421]/70 text-sm mt-2">Colaborăm cu mai multe firme de încredere — la cerere îți punem la dispoziție contactul celor care se ocupă de catering, decor și baloane.</div>
          </div>
        </div>
      </div>
    </section>
  );
}
